import { vinnV1Api } from "services/vinn-api-v1";

const inventoryApi = vinnV1Api.injectEndpoints({
  endpoints: (builder) => ({
    getInventory: builder.query({
      query: (params) => ({
        url: "/pages/inventory",
        params: { view: "inventory", ...params },
      }),
      providesTags: () => [{ type: "Listings" }],
    }),
    getInventoryCount: builder.query({
      query: (params) => ({
        url: "/pages/inventory/count",
        params,
      }),
      providesTags: () => [{ type: "Listings" }],
    }),
    getRecommendedInventory: builder.query({
      query: (params) => ({
        url: "/pages/inventory/recommender",
        params: { view: "inventory", ...params },
      }),
      providesTags: () => [{ type: "Listings" }],
    }),
  }),
});

export const {
  useGetInventoryQuery,
  useGetInventoryCountQuery,
  useGetRecommendedInventoryQuery,
} = inventoryApi;
